/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Layout } from 'components';

import Loader from 'components/Loader';
import { FitinsurAPI, MessageCenter, ApiNotification } from 'utils';
import Colors from 'constants/Colors';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';

export default function NotificationProxy(props) {
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const history = useHistory();
  const apiNotification = new ApiNotification();

  const checkOperationRouteEnquiry = (res) => {
    let route = "";
    const { idOperationParent, idProduct, idOperation, idNavigation } = res.ret_value;
    // eslint-disable-next-line default-case
    switch (idNavigation) {
      case 1:
        route = `/edit-enquirity/${idProduct}/${idOperation}${idOperationParent ? `/${idOperationParent}` : ""}`;
        break;
      case 2:
        route = `/edit-enquirity/${idProduct}/${idOperation}${idOperationParent ? `/${idOperationParent}` : ""}`;
        break;
      case 3:
        route = `/broking/approval-nbi/${idOperation}`;
        break;
      case 4:
        if (idProduct == "16") {
          route = `/broking/select-markets/${idOperation}/${idProduct}`;
        } else {
          route = `/broking/select-markets/${idOperation}`;
        }
        break;
      case 5:
        route = `/broking/contacts-selection/${idOperation}`;
        break;
      case 6:
        route = `/broking/nbi-request/${idOperation}`;
        break;
      case 7:
        route = `/broking/send-nbi-request/${idOperation}`;
        break;
      case 8:
        route = `/broking/market-selection/${idOperation}`;
        break;
      case 9:
        route = `/broking/document-nbi-status/${idOperation}`;
        break;
      case 10:
        route = `/broking/approval-nbi-cv/${idOperation}`;
        break;
      case 11:
        route = `/broking/nbi-request-cv/${idOperation}`;
        break;
      case 12:
        route = `/broking/market-composition/${idOperation}`;
        break;
      case 13:
        route = `/broking/policy-pack-approval/${idOperation}`;
        break;
      case 14:
        route = `/broking/approval-policy-pack/${idOperation}`;
        break;
      case 15:
        route = `/broking/send-policy-pack-client/${idOperation}`;
        break;
      case 16:
        route = `/broking/send-approval-pack/${idOperation}`;
        break;
      case 17:
        route = `/broking/send-order-to-bind/${idOperation}`;
        break;
      case 18:
        route = `/broking/order-to-bind/${idOperation}`;
        break;
      case 19:
        route = `/broking/order-to-bind/${idOperation}`;
        break;
      case 20:
        route = `/broking/stamps-status-list/${idOperation}`;
        break;
      case 21:
        route = `/broking/payment-pack-send-approval/${idOperation}`;
        break;
      case 22:
        route = `/broking/payment-pack-send-client-insurer/${idOperation}`;
        break;
      case 23:
        route = `/broking/payment-pack-approval/${idOperation}`;
        break;
      case 24:
        route = `/broking/send-nbi-cv/${idOperation}`;
        break;
      case 25:
        route = `/edit-master-policy/${idProduct}/${idOperation}`;
        break;
      case 26:
        route = `/broking/send-approval-pack-declaration/${idOperation}`;
        break;
      case 99:
        route = `/edit-enquirity/${idProduct}/${idOperation}${idOperationParent ? `/${idOperationParent}` : ""}`;
        break;
    }

    if (route) {
      loading.stop();
      history.replace(
        {
          pathname: route,
          state: res.ret_value.idNavigation == 99 ? { disabled: true, idProduct: idProduct } : { idProduct: idProduct }
        })
    } else {
      mc.error('NAVIGATION NOT DEFINED');
      loading.stop();
    }
  }

  const checkOperationRoute = (idOperation) => {
    fitinsur.setAuthToken(authContext.token);
    loading.start();

    fitinsur.requestPolicyNavigation(idOperation).then(x => x.json()).then(res => {
      loading.stop();

      if (res.ret_code != 200) {
        mc.error(res.ret_msg_details);
        return;
      }

      let { route, idNavigation } = res.ret_value;

      if (idNavigation) return checkOperationRouteEnquiry(res);

      if (route) {
        history.replace({ pathname: route })
      } else {
        mc.error('NAVIGATION NOT DEFINED');
        loading.stop();
      }
    }).catch(() => loading.stop());
  }


  useEffect(() => {
    checkOperationRoute(props.match.params.idOperation);
    //TODO MARCAR COMO LIDA

    apiNotification.setAuthToken(authContext.token);
    apiNotification.markAsRead(props.match.params.idNotification).then((response) => response.json());
  }, [])


  return (
    <Layout title={'Wait...'}>
      {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
    </Layout>
  );
}
